import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./country-selection.${locale}.json`));
